/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const updatePolicyPlanSyncBodyBlockThresholdMin = 0;
export const updatePolicyPlanSyncBodyBlockThresholdMax = 1;

export const updatePolicyPlanSyncBodyReviewThresholdMin = 0;
export const updatePolicyPlanSyncBodyReviewThresholdMax = 1;

export const updatePolicyPlanSyncBodySeverityMax = 5;

export const UpdatePolicyPlanSyncBody = zod
	.object({
		action_canvas: zod.record(zod.string(), zod.unknown()).optional(),
		block_threshold: zod
			.number()
			.min(updatePolicyPlanSyncBodyBlockThresholdMin)
			.max(updatePolicyPlanSyncBodyBlockThresholdMax)
			.optional()
			.describe('Block threshold as a decimal'),
		display_name: zod.string().nullish().describe('Policy plan display name'),
		formats: zod
			.array(zod.enum(['text', 'image']))
			.optional()
			.describe('Content formats'),
		review_threshold: zod
			.number()
			.min(updatePolicyPlanSyncBodyReviewThresholdMin)
			.max(updatePolicyPlanSyncBodyReviewThresholdMax)
			.optional()
			.describe('Review threshold as a decimal'),
		severity: zod
			.number()
			.min(1)
			.max(updatePolicyPlanSyncBodySeverityMax)
			.nullish()
			.describe('Severity level (1-5)')
	})
	.describe('Request body for updating a policy plan');

export type UpdatePolicyPlanSyncBody = zod.input<typeof UpdatePolicyPlanSyncBody>;
export type UpdatePolicyPlanSyncBodyOutput = zod.output<typeof UpdatePolicyPlanSyncBody>;
